/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfString } from '../models/custom-result-of-string';
import { smartSmsRecipientsCreateP2PSmartSmsRecipientsGet } from '../fn/smart-sms-recipients/smart-sms-recipients-create-p-2-p-smart-sms-recipients-get';
import { SmartSmsRecipientsCreateP2PSmartSmsRecipientsGet$Params } from '../fn/smart-sms-recipients/smart-sms-recipients-create-p-2-p-smart-sms-recipients-get';
import { smartSmsRecipientsCreateP2PSmartSmsRecipientsPost } from '../fn/smart-sms-recipients/smart-sms-recipients-create-p-2-p-smart-sms-recipients-post';
import { SmartSmsRecipientsCreateP2PSmartSmsRecipientsPost$Params } from '../fn/smart-sms-recipients/smart-sms-recipients-create-p-2-p-smart-sms-recipients-post';
import { smartSmsRecipientsCreatePeriodicSmartSmsRecipientGet } from '../fn/smart-sms-recipients/smart-sms-recipients-create-periodic-smart-sms-recipient-get';
import { SmartSmsRecipientsCreatePeriodicSmartSmsRecipientGet$Params } from '../fn/smart-sms-recipients/smart-sms-recipients-create-periodic-smart-sms-recipient-get';
import { smartSmsRecipientsCreatePeriodicSmartSmsRecipientPost } from '../fn/smart-sms-recipients/smart-sms-recipients-create-periodic-smart-sms-recipient-post';
import { SmartSmsRecipientsCreatePeriodicSmartSmsRecipientPost$Params } from '../fn/smart-sms-recipients/smart-sms-recipients-create-periodic-smart-sms-recipient-post';
import { smartSmsRecipientsCreateSmartSmsRecipientByFileGet } from '../fn/smart-sms-recipients/smart-sms-recipients-create-smart-sms-recipient-by-file-get';
import { SmartSmsRecipientsCreateSmartSmsRecipientByFileGet$Params } from '../fn/smart-sms-recipients/smart-sms-recipients-create-smart-sms-recipient-by-file-get';
import { smartSmsRecipientsCreateSmartSmsRecipientByFilePost } from '../fn/smart-sms-recipients/smart-sms-recipients-create-smart-sms-recipient-by-file-post';
import { SmartSmsRecipientsCreateSmartSmsRecipientByFilePost$Params } from '../fn/smart-sms-recipients/smart-sms-recipients-create-smart-sms-recipient-by-file-post';
import { smartSmsRecipientsCreateSmartSmsRecipientGet } from '../fn/smart-sms-recipients/smart-sms-recipients-create-smart-sms-recipient-get';
import { SmartSmsRecipientsCreateSmartSmsRecipientGet$Params } from '../fn/smart-sms-recipients/smart-sms-recipients-create-smart-sms-recipient-get';
import { smartSmsRecipientsCreateSmartSmsRecipientPost } from '../fn/smart-sms-recipients/smart-sms-recipients-create-smart-sms-recipient-post';
import { SmartSmsRecipientsCreateSmartSmsRecipientPost$Params } from '../fn/smart-sms-recipients/smart-sms-recipients-create-smart-sms-recipient-post';
import { smartSmsRecipientsDownloadSmartSmsRecipientGet } from '../fn/smart-sms-recipients/smart-sms-recipients-download-smart-sms-recipient-get';
import { SmartSmsRecipientsDownloadSmartSmsRecipientGet$Params } from '../fn/smart-sms-recipients/smart-sms-recipients-download-smart-sms-recipient-get';
import { smartSmsRecipientsDownloadSmartSmsRecipientPost } from '../fn/smart-sms-recipients/smart-sms-recipients-download-smart-sms-recipient-post';
import { SmartSmsRecipientsDownloadSmartSmsRecipientPost$Params } from '../fn/smart-sms-recipients/smart-sms-recipients-download-smart-sms-recipient-post';
import { smartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdGet } from '../fn/smart-sms-recipients/smart-sms-recipients-download-smart-sms-recipients-by-outbox-message-id-get';
import { SmartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdGet$Params } from '../fn/smart-sms-recipients/smart-sms-recipients-download-smart-sms-recipients-by-outbox-message-id-get';
import { smartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdPost } from '../fn/smart-sms-recipients/smart-sms-recipients-download-smart-sms-recipients-by-outbox-message-id-post';
import { SmartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdPost$Params } from '../fn/smart-sms-recipients/smart-sms-recipients-download-smart-sms-recipients-by-outbox-message-id-post';

@Injectable({ providedIn: 'root' })
export class SmartSmsRecipientsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `smartSmsRecipientsCreateSmartSmsRecipientGet()` */
  static readonly SmartSmsRecipientsCreateSmartSmsRecipientGetPath = '/SmartSmsRecipients/CreateSmartSmsRecipient';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRecipientsCreateSmartSmsRecipientGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRecipientsCreateSmartSmsRecipientGet$Response(params?: SmartSmsRecipientsCreateSmartSmsRecipientGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return smartSmsRecipientsCreateSmartSmsRecipientGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRecipientsCreateSmartSmsRecipientGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRecipientsCreateSmartSmsRecipientGet(params?: SmartSmsRecipientsCreateSmartSmsRecipientGet$Params, context?: HttpContext): Observable<Blob> {
    return this.smartSmsRecipientsCreateSmartSmsRecipientGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `smartSmsRecipientsCreateSmartSmsRecipientPost()` */
  static readonly SmartSmsRecipientsCreateSmartSmsRecipientPostPath = '/SmartSmsRecipients/CreateSmartSmsRecipient';

  /**
   * Create SmartSmsRecipient.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRecipientsCreateSmartSmsRecipientPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRecipientsCreateSmartSmsRecipientPost$Response(params: SmartSmsRecipientsCreateSmartSmsRecipientPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smartSmsRecipientsCreateSmartSmsRecipientPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create SmartSmsRecipient.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRecipientsCreateSmartSmsRecipientPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRecipientsCreateSmartSmsRecipientPost(params: SmartSmsRecipientsCreateSmartSmsRecipientPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smartSmsRecipientsCreateSmartSmsRecipientPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smartSmsRecipientsCreatePeriodicSmartSmsRecipientGet()` */
  static readonly SmartSmsRecipientsCreatePeriodicSmartSmsRecipientGetPath = '/SmartSmsRecipients/CreatePeriodicSmartSmsRecipient';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRecipientsCreatePeriodicSmartSmsRecipientGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRecipientsCreatePeriodicSmartSmsRecipientGet$Response(params?: SmartSmsRecipientsCreatePeriodicSmartSmsRecipientGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return smartSmsRecipientsCreatePeriodicSmartSmsRecipientGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRecipientsCreatePeriodicSmartSmsRecipientGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRecipientsCreatePeriodicSmartSmsRecipientGet(params?: SmartSmsRecipientsCreatePeriodicSmartSmsRecipientGet$Params, context?: HttpContext): Observable<Blob> {
    return this.smartSmsRecipientsCreatePeriodicSmartSmsRecipientGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `smartSmsRecipientsCreatePeriodicSmartSmsRecipientPost()` */
  static readonly SmartSmsRecipientsCreatePeriodicSmartSmsRecipientPostPath = '/SmartSmsRecipients/CreatePeriodicSmartSmsRecipient';

  /**
   * ارسال دوره ای هوشمند.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRecipientsCreatePeriodicSmartSmsRecipientPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRecipientsCreatePeriodicSmartSmsRecipientPost$Response(params: SmartSmsRecipientsCreatePeriodicSmartSmsRecipientPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smartSmsRecipientsCreatePeriodicSmartSmsRecipientPost(this.http, this.rootUrl, params, context);
  }

  /**
   * ارسال دوره ای هوشمند.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRecipientsCreatePeriodicSmartSmsRecipientPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRecipientsCreatePeriodicSmartSmsRecipientPost(params: SmartSmsRecipientsCreatePeriodicSmartSmsRecipientPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smartSmsRecipientsCreatePeriodicSmartSmsRecipientPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smartSmsRecipientsCreateP2PSmartSmsRecipientsGet()` */
  static readonly SmartSmsRecipientsCreateP2PSmartSmsRecipientsGetPath = '/SmartSmsRecipients/CreateP2PSmartSmsRecipients';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRecipientsCreateP2PSmartSmsRecipientsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRecipientsCreateP2PSmartSmsRecipientsGet$Response(params?: SmartSmsRecipientsCreateP2PSmartSmsRecipientsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return smartSmsRecipientsCreateP2PSmartSmsRecipientsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRecipientsCreateP2PSmartSmsRecipientsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRecipientsCreateP2PSmartSmsRecipientsGet(params?: SmartSmsRecipientsCreateP2PSmartSmsRecipientsGet$Params, context?: HttpContext): Observable<Blob> {
    return this.smartSmsRecipientsCreateP2PSmartSmsRecipientsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `smartSmsRecipientsCreateP2PSmartSmsRecipientsPost()` */
  static readonly SmartSmsRecipientsCreateP2PSmartSmsRecipientsPostPath = '/SmartSmsRecipients/CreateP2PSmartSmsRecipients';

  /**
   * ارسال نظیر به نظیر هوشمند.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRecipientsCreateP2PSmartSmsRecipientsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRecipientsCreateP2PSmartSmsRecipientsPost$Response(params: SmartSmsRecipientsCreateP2PSmartSmsRecipientsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smartSmsRecipientsCreateP2PSmartSmsRecipientsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * ارسال نظیر به نظیر هوشمند.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRecipientsCreateP2PSmartSmsRecipientsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRecipientsCreateP2PSmartSmsRecipientsPost(params: SmartSmsRecipientsCreateP2PSmartSmsRecipientsPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smartSmsRecipientsCreateP2PSmartSmsRecipientsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smartSmsRecipientsCreateSmartSmsRecipientByFileGet()` */
  static readonly SmartSmsRecipientsCreateSmartSmsRecipientByFileGetPath = '/SmartSmsRecipients/CreateSmartSmsRecipientByFile';

  /**
   * ارسال هوشمند با فایل.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRecipientsCreateSmartSmsRecipientByFileGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRecipientsCreateSmartSmsRecipientByFileGet$Response(params?: SmartSmsRecipientsCreateSmartSmsRecipientByFileGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return smartSmsRecipientsCreateSmartSmsRecipientByFileGet(this.http, this.rootUrl, params, context);
  }

  /**
   * ارسال هوشمند با فایل.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRecipientsCreateSmartSmsRecipientByFileGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRecipientsCreateSmartSmsRecipientByFileGet(params?: SmartSmsRecipientsCreateSmartSmsRecipientByFileGet$Params, context?: HttpContext): Observable<Blob> {
    return this.smartSmsRecipientsCreateSmartSmsRecipientByFileGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `smartSmsRecipientsCreateSmartSmsRecipientByFilePost()` */
  static readonly SmartSmsRecipientsCreateSmartSmsRecipientByFilePostPath = '/SmartSmsRecipients/CreateSmartSmsRecipientByFile';

  /**
   * ارسال هوشمند با فایل.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRecipientsCreateSmartSmsRecipientByFilePost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  smartSmsRecipientsCreateSmartSmsRecipientByFilePost$Response(params?: SmartSmsRecipientsCreateSmartSmsRecipientByFilePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smartSmsRecipientsCreateSmartSmsRecipientByFilePost(this.http, this.rootUrl, params, context);
  }

  /**
   * ارسال هوشمند با فایل.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRecipientsCreateSmartSmsRecipientByFilePost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  smartSmsRecipientsCreateSmartSmsRecipientByFilePost(params?: SmartSmsRecipientsCreateSmartSmsRecipientByFilePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smartSmsRecipientsCreateSmartSmsRecipientByFilePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smartSmsRecipientsDownloadSmartSmsRecipientGet()` */
  static readonly SmartSmsRecipientsDownloadSmartSmsRecipientGetPath = '/SmartSmsRecipients/DownloadSmartSmsRecipient';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRecipientsDownloadSmartSmsRecipientGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRecipientsDownloadSmartSmsRecipientGet$Response(params?: SmartSmsRecipientsDownloadSmartSmsRecipientGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return smartSmsRecipientsDownloadSmartSmsRecipientGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRecipientsDownloadSmartSmsRecipientGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRecipientsDownloadSmartSmsRecipientGet(params?: SmartSmsRecipientsDownloadSmartSmsRecipientGet$Params, context?: HttpContext): Observable<Blob> {
    return this.smartSmsRecipientsDownloadSmartSmsRecipientGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `smartSmsRecipientsDownloadSmartSmsRecipientPost()` */
  static readonly SmartSmsRecipientsDownloadSmartSmsRecipientPostPath = '/SmartSmsRecipients/DownloadSmartSmsRecipient';

  /**
   * دریافت لینک دانلود فایل ارسال درخواست ارسال هوشمند.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRecipientsDownloadSmartSmsRecipientPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRecipientsDownloadSmartSmsRecipientPost$Response(params: SmartSmsRecipientsDownloadSmartSmsRecipientPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfString>> {
    return smartSmsRecipientsDownloadSmartSmsRecipientPost(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لینک دانلود فایل ارسال درخواست ارسال هوشمند.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRecipientsDownloadSmartSmsRecipientPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRecipientsDownloadSmartSmsRecipientPost(params: SmartSmsRecipientsDownloadSmartSmsRecipientPost$Params, context?: HttpContext): Observable<CustomResultOfString> {
    return this.smartSmsRecipientsDownloadSmartSmsRecipientPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfString>): CustomResultOfString => r.body)
    );
  }

  /** Path part for operation `smartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdGet()` */
  static readonly SmartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdGetPath = '/SmartSmsRecipients/DownloadSmartSmsRecipientsByOutboxMessageId';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdGet$Response(params?: SmartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return smartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdGet(params?: SmartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdGet$Params, context?: HttpContext): Observable<Blob> {
    return this.smartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `smartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdPost()` */
  static readonly SmartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdPostPath = '/SmartSmsRecipients/DownloadSmartSmsRecipientsByOutboxMessageId';

  /**
   * دریافت لینک دانلود فایل ارسال درخواست ارسال هوشمند با شناسه صندوق.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdPost$Response(params: SmartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfString>> {
    return smartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لینک دانلود فایل ارسال درخواست ارسال هوشمند با شناسه صندوق.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdPost(params: SmartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdPost$Params, context?: HttpContext): Observable<CustomResultOfString> {
    return this.smartSmsRecipientsDownloadSmartSmsRecipientsByOutboxMessageIdPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfString>): CustomResultOfString => r.body)
    );
  }

}
